<!-- Overlay -->
<div class="mobile-nav__wrapper" [class.expanded]="mobileNav.isOpen()">

    <div class="mobile-nav__overlay" (click)="mobileNav.close()"></div>

    <div class="mobile-nav__content">

        <!-- Bouton fermer -->
        <span class="mobile-nav__close" (click)="mobileNav.close()">
            <i class="fa fa-times"></i>
        </span>

        <!-- Logo -->
        <div class="logo-box">
            <a [routerLink]="['/']" (click)="mobileNav.close()"> 
                <img src="/logo-header.png" alt="ARP" style="height: 70px;max-width: 240px;">
            </a>
        </div>

        <!-- Navigation -->
        <div class="mobile-nav__container">
            <ul class="mobile-menu__list">

                <!-- Accueil -->
                <li>
                    <a [routerLink]="['/']" (click)="mobileNav.close()">
                        {{ 'HOME' | translate }}
                    </a>
                </li>

                <!-- ARP -->
                <li class="mobile-menu__item--has-children" [class.open]="isOpen('arp')">
                    <a href="#" (click)="toggleSub('arp', $event)">{{ 'ARP' | translate }}</a>
                    <ul class="mobile-menu__sub">
                        <li><a href="/#about"    (click)="mobileNav.close()">{{ "Présentation de l'Institution" | translate }}</a></li>
                        <li><a href="/#missions" (click)="mobileNav.close()">{{ "Missions"                      | translate }}</a></li>
                        <li><a [routerLink]="['/page','conseil-arp']" (click)="mobileNav.close()">{{ "Conseil de l'ARP" | translate }}</a></li>
                        <li style="display: none;"><a [routerLink]="['/autorite/bureau']" (click)="mobileNav.close()">{{ 'autorite_menu_bureau' | translate }}</a></li>
                        <li><a [routerLink]="['/autorite/comites']" (click)="mobileNav.close()">{{ 'autorite_menu_comites' | translate }}</a></li>
                        <li><a [routerLink]="['/autorite/anciens-presidents']" (click)="mobileNav.close()">{{ 'autorite_menu_anciens' | translate }}</a></li>
                    </ul>
                </li>

                <!-- Cadre légal -->
                <li class="mobile-menu__item--has-children" [class.open]="isOpen('loi')">
                    <a href="#" (click)="toggleSub('loi', $event)">{{ 'loi_menu' | translate }}</a>
                    <ul class="mobile-menu__sub">
                        <li><a [routerLink]="['/loi']" [queryParams]="{category:'loi'}"        (click)="mobileNav.close()">{{ 'loi_menu_lois_decrets' | translate }}</a></li>
                        <li><a [routerLink]="['/loi']" [queryParams]="{category:'arrete'}"     (click)="mobileNav.close()">{{ 'loi_menu_arretes'      | translate }}</a></li>
                        <li><a [routerLink]="['/loi']" [queryParams]="{category:'circulaire'}" (click)="mobileNav.close()">{{ 'loi_menu_decisions'    | translate }}</a></li>
                        <li><a [routerLink]="['/loi']"                                         (click)="mobileNav.close()">{{ 'loi_menu_tout'         | translate }}</a></li>
                    </ul>
                </li>

                <!-- Licences -->
                <li class="mobile-menu__item--has-children" [class.open]="isOpen('licences')">
                    <a href="#" (click)="toggleSub('licences', $event)">{{ "Licences et Autorisations" | translate }}</a>
                    <ul class="mobile-menu__sub"> 
                        <li><a [routerLink]="['/page','conditions-agrement-autorisation']"      (click)="mobileNav.close()">{{ "Conditions d'agrément et d'autorisation" | translate }}</a></li>
                        <li><a [routerLink]="['/annuaire']"                (click)="mobileNav.close()">{{ 'annuaire_menu'                           | translate }}</a></li>
                    </ul>
                </li>

                <!-- Plaintes -->
                <li class="mobile-menu__item--has-children" [class.open]="isOpen('plaintes')">
                    <a href="#" (click)="toggleSub('plaintes', $event)">{{ "Plaintes" | translate }}</a>
                    <ul class="mobile-menu__sub">
                        <li><a [routerLink]="['/plainte']"           (click)="mobileNav.close()">{{ 'plainte_menu_deposer'     | translate }}</a></li>
                        <li><a [routerLink]="['/signalement']"       (click)="mobileNav.close()">{{ 'signal_menu_deposer'      | translate }}</a></li>
                        <li><a [routerLink]="['/suivi-plainte']"     (click)="mobileNav.close()">{{ 'suivi_menu'               | translate }}</a></li>
                        <li><a [routerLink]="['/page','plan_action']"(click)="mobileNav.close()">{{ "Protection du consommateur" | translate }}</a></li>
                    </ul>
                </li>

                <!-- Publications -->
                <li class="mobile-menu__item--has-children" [class.open]="isOpen('pub')">
                    <a href="#" (click)="toggleSub('pub', $event)">{{ 'pub_publications' | translate }}</a>
                    <ul class="mobile-menu__sub">
                        <li><a [routerLink]="['/articles']"  [queryParams]="{category_slug:'actualites'}"  (click)="mobileNav.close()">{{ 'pub_actualites' | translate }}</a></li>
                        <li><a [routerLink]="['/articles']"  [queryParams]="{category_slug:'evenements'}"  (click)="mobileNav.close()">{{ 'pub_evenements' | translate }}</a></li>
                        <li><a [routerLink]="['/articles']"  [queryParams]="{category_slug:'communiques'}" (click)="mobileNav.close()">{{ 'pub_communiques'| translate }}</a></li>
                        <li><a [routerLink]="['/articles']"  [queryParams]="{category_slug:'ofres-et-marches'}" (click)="mobileNav.close()">{{ 'pub_ofres_marches'| translate }}</a></li>
                        <li><a [routerLink]="['/documents']" [queryParams]="{type:'document'}"             (click)="mobileNav.close()">{{ 'pub_documents'  | translate }}</a></li>
                        <li><a [routerLink]="['/documents']" [queryParams]="{type:'rapport_annuel'}"       (click)="mobileNav.close()">{{ 'pub_rapports'   | translate }}</a></li>
                        <li><a [routerLink]="['/galerie']"                                                 (click)="mobileNav.close()">{{ 'galerie_menu'   | translate }}</a></li>
                    </ul>
                </li>

                <!-- Contact -->
                <li>
                    <a [routerLink]="['/contact']" (click)="mobileNav.close()">
                        {{ 'CONTACT' | translate }}
                    </a>
                </li>

                <!-- Langue -->
                <li class="mobile-menu__item--has-children" [class.open]="isOpen('lang')">
                    <a href="#" (click)="toggleSub('lang', $event)">🌐 Langue</a>
                    <ul class="mobile-menu__sub">
                        <li><a href="#" (click)="$event.preventDefault(); switchLanguage('ar')">🇲🇷 العربية</a></li>
                        <li><a href="#" (click)="$event.preventDefault(); switchLanguage('fr')">🇫🇷 Français</a></li>
                        <li><a href="#" (click)="$event.preventDefault(); switchLanguage('en')">🇬🇧 English</a></li>
                    </ul>
                </li>

            </ul>
        </div><!-- /.mobile-nav__container -->

    </div><!-- /.mobile-nav__content -->
</div><!-- /.mobile-nav__wrapper -->
